import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  TextField,
} from '@mui/material';
import {
  IStateProps,
  IProps,
} from './interfaces';
import { IAppState } from '../../../../../state/reducers';
import {
  updatePublishingMetadataField,
  clearSocialPublishing,
} from '../../../../../state/publishAssets';
import {
  ControlLabel,
  ControlContainer,
  LabelContainer,
  CharactersLeft,
} from './styles';
import { SocialPublish } from '../../../../../constants';
import { selectTitleForNewAsset } from '../../../../VirtualClipper/state/clipList';

class AssetTitleForVaultPublishOptions extends React.Component<IProps> {
  private static readonly titleInputID = 'AssetTitleForVaultPublishOptions.title';

  componentDidMount() {
    const {
      newAssetTitle,
      updatePublishingMetadataFieldConnect,
    } = this.props;

    updatePublishingMetadataFieldConnect('title', newAssetTitle);
  }

  componentWillUnmount() {
    const { clearSocialPublishingConnect } = this.props;

    clearSocialPublishingConnect();
  }

  selectEnteredValue = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();
  };

  render() {
    const {
      socialPublishing: {
        metadata,
      },
      updatePublishingMetadataFieldConnect,
    } = this.props;

    if (metadata === null) {
      return null;
    }

    const { title } = metadata;

    return (
      <ControlContainer>
        <LabelContainer>
          <ControlLabel>Title *</ControlLabel>
          <CharactersLeft>
            {SocialPublish.FIELDS_MAX_LENGTH.get('title') - title.length}
          </CharactersLeft>
        </LabelContainer>
        <TextField
          id={AssetTitleForVaultPublishOptions.titleInputID}
          fullWidth
          margin="dense"
          variant="outlined"
          value={title}
          onChange={(e) => updatePublishingMetadataFieldConnect('title', e.target.value)}
          inputProps={{
            maxLength: SocialPublish.FIELDS_MAX_LENGTH.get('title'),
          }}
          onFocus={this.selectEnteredValue}
        />
      </ControlContainer>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  socialPublishing: state.publishSelectedAssetsToEndPoints.socialPublishing,
  newAssetTitle: selectTitleForNewAsset(state),
});

const mapDispatchToProps = {
  clearSocialPublishingConnect: clearSocialPublishing,
  updatePublishingMetadataFieldConnect: updatePublishingMetadataField,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetTitleForVaultPublishOptions);
